"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createVariant = void 0;
var _constants = require("../constants");
var _constants2 = require("./constants");
const createVariant = ({
  baseUrl,
  variant,
  backgroundColor,
  imageSizeMultiplier = _constants.IMAGE_SIZE_MULTIPLIER,
  excludeWidthFromUrl,
  imageFormat
}) => {
  const variantURL = new URL(baseUrl.toString());
  if (!excludeWidthFromUrl) {
    const width = variant.width * imageSizeMultiplier;
    variantURL.searchParams.set(_constants2.WIDTH_PARAM, width.toString());
  }
  if (typeof backgroundColor === 'string') {
    variantURL.searchParams.set(_constants2.BACKGROUND_PARAM, backgroundColor);
    variantURL.searchParams.set(_constants2.IMAGE_BACKGROUND_PARAM, backgroundColor);
  }
  if (variant.height !== undefined) {
    const height = variant.height * imageSizeMultiplier;
    variantURL.searchParams.set(_constants2.HEIGHT_PARAM, height.toString());
  }
  if (variant.quality !== undefined) {
    variantURL.searchParams.set(_constants2.QUALITY_PARAM, variant.quality.toString());
  }
  if (imageFormat) {
    variantURL.searchParams.set(_constants2.IMAGE_FORMAT_PARAM, imageFormat);
  }
  return {
    width: variant.width,
    url: variantURL.toString()
  };
};
exports.createVariant = createVariant;
